import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../features/auth/Login";
import DashboardLayout from "../features/layout/DashboardLayout";
import Profile from "../pages/Profile";
import Register from "../features/auth/Register";
import ForgotPassword from "../features/auth/ForgotPassword";
import FormBuilderComponent from "../pages/FormCreation/FormCreation";
import PermissionTable from "../pages/Role/ListOfRoles";
import NotFound from "../pages/Notfound/Notfound";
import ProjectMaster from "../pages/Projects Management/CreateProject";
import ProjectList from "../pages/Projects Management/ProjectList";
import CoreTeamCreate from "../pages/CoreTeam/CreateTeam";
import CoreTeamList from "../pages/CoreTeam/CoreTeamList";
import RoleList from "../pages/Role/RoleManagement";
import Dashboard from "../pages/Dashboard";
import SurveyList from "../pages/FormCreation/SurveyListing";
import CreateSurvey from "../pages/FormCreation/CreateSurvey";
import ResetPassword from "../features/auth/ResetPassword";
import SurveyHistory from "../pages/FormCreation/SurveyHistory";
import SurveyDetail from "../pages/FormCreation/SurveyDetails";
import ReportManagement from "../pages/Report Management";
// ✅ Define routes in an array
const dashboardRoutes = [
  { path: "home", element: <Dashboard /> },
  { path: "profile", element: <Profile /> },
  { path: "projectCreate", element: <ProjectMaster /> },
  { path: "projectUpdate", element: <ProjectMaster /> },
  { path: "projectList", element: <ProjectList /> },
  { path: "updateUser", element: <CoreTeamCreate /> },
  { path: "userCreate", element: <CoreTeamCreate /> },
  { path: "userListing", element: <CoreTeamList /> },
  { path: "createsurvey", element: <CreateSurvey /> },
  { path: "updatesurvey", element: <CreateSurvey /> },
  { path: "formCreation", element: <FormBuilderComponent /> },
  { path: "formUpdation", element: <FormBuilderComponent /> },
  { path: "surveyListing", element: <SurveyList /> },
  { path: "surveyHistory", element: <SurveyHistory /> },
  { path: "surveyDetails", element: <SurveyDetail /> },
  { path: "createrole", element: <RoleList /> },
  { path: "updaterole", element: <RoleList /> },
  { path: "rolemanagement", element: <PermissionTable /> },
  { path: "reportmanagement", element: <ReportManagement /> },
];

// Protected Route Wrapper
const ProtectedRoute = ({ redirectPath = "/" }) => {
  const isAuthenticated = localStorage.getItem("token");

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

// Public Route Wrapper (for routes like login that should only be accessible when not authenticated)
const PublicRoute = ({ redirectPath = "/dashboard" }) => {
  const isAuthenticated = localStorage.getItem("token");

  if (isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicRoute />}>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
      </Route>
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Dashboard />} />
          {dashboardRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>
      </Route>
      {/* Fallback 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
